import request from '../utils/request'

const tenantService = {
    createTenant: (params) => {
        return request({
            url:'/tenant/create',
            method:'post',
            data:params
        })
    },
    getTenantList:(params)=>{
        return request({
            url:'/tenant/getTenantList',
            method:'post',
            data:params
        })
    },
}



export default tenantService